import { connect } from 'react-redux'
import FlowLogs from './FlowLogs'
import { getFlowLogs, getFlows } from 'features/Flows/Flows.actions'
import { get, flow } from 'lodash'
import { replace } from 'react-router-redux'
import { reduxForm } from 'redux-form'

const formName = 'flowLogs'

const stateToProps = ({ flows, form }, { params: { flowId }, location: { query } }) => {
  const formData = get(form, [formName, 'values'], {})
  const page = parseInt(query.page, 10) || 1
  const cacheKey = `${flowId}-${page}`
  const flowLogs = get(flows, ['flowLogs', cacheKey], {})

  return {
    flow: flows.flowsById[flowId],
    flowId,
    loading: flowLogs.loading,
    totalPages: get(flowLogs, 'data.totalPages', 1),
    results: get(flowLogs, 'data.results', []).map(flowLogId => flows.flowLogsById[flowLogId].data),
    page,
    formData,
    cacheKey,
  }
}

const dispatchToProps = {
  getFlowLogs,
  getFlows,
  replace,
}

export default flow(connect(stateToProps, dispatchToProps), reduxForm({ form: formName }))(FlowLogs)



// WEBPACK FOOTER //
// ./src/pages/FlowLogs/FlowLogs.container.js